import { $getNodeByKey, type EditorState, type NodeKey } from "lexical";
import type { BlockId } from "../../core/types";
import { $getBlockId, $isIdentified } from "./state";

interface UpdateLike {
  editorState: EditorState;
  prevEditorState: EditorState;
  dirtyElements: ReadonlyMap<NodeKey, boolean>;
  dirtyLeaves: ReadonlySet<NodeKey>;
}

/**
 * The IDs of identified nodes an update touched. Lexical already marks the ancestors of edited
 * text as dirty, so this only looks the dirty keys up: once in the new state, and once in the old
 * one for blocks that are gone or were re-identified.
 */
export function $changedBlockIds(update: UpdateLike): BlockId[] {
  const keys = [...update.dirtyElements.keys(), ...update.dirtyLeaves];
  const ids = new Set<BlockId>();
  const collect = (): void => {
    for (const key of keys) {
      const node = $getNodeByKey(key);
      if (node === null || !$isIdentified(node)) continue;
      const id = $getBlockId(node);
      if (id !== null) ids.add(id);
    }
  };
  update.editorState.read(collect);
  update.prevEditorState.read(collect);
  return [...ids];
}
